import { slugify } from '../../base'
import { useNavigate } from 'react-router-dom'
import {LazyImage} from '../../base'
import { url } from '../../base/Variables'

function CategoryCard({ category }) {
  const navigate = useNavigate()

  return (
    <div className='categoryCard'>
      <LazyImage src={`${url}${category.image}`} alt={category.name}/>
      <div className='h6' onClick={() => navigate(`/p/shop/all/category/${slugify(category.name)}/products/`)}>{category.name}</div>
    </div>
  )
}

export default CategoryCard